<template>
    <div class="clearfix">
        <line-chart :id="id" :option="chartOptions"></line-chart>

        <div class="table-box" style="border: 0">
            <div class="title">
                <h3>实验学习情况</h3>
            </div>
            <div class="search-box" style="padding: 10px 0">
                <Select v-model="model1"
                        style="width:140px;margin-right: 10px"
                >
                    <Option :value="item.value"  v-for="item in courseArr" :key="item.value">{{item.title}}</Option>
                </Select>
                <Select v-model="model2"
                        style="width:140px;margin-right: 10px"
                >
                    <Option :value="item.value"  v-for="item in classArr" :key="item.value">{{item.title}}</Option>
                </Select>
                <Select v-model="model4"
                        style="width:140px;margin-right: 10px"
                >
                    <Option :value="item.value"  v-for="item in statusArr" :key="item.value">{{item.title}}</Option>
                </Select>
            </div>
            <Table ref="selection" :columns="columns" :data="datas" ></Table>
        </div>
    </div>
</template>

<script>
    import lineChart from '../../../../ability/chart/chart'
    export default {
        name: "labLearn",
        components: {
            lineChart
        },
        data(){
            return{
                id:'test',
                chartOptions:{
                    chart: {
                        type: 'column'
                    },
                    title: {
                        text: '热门实验（次）'
                    },
                    // subtitle: {
                    //     text: '数据截止 2017-03，来源: <a href="https://en.wikipedia.org/wiki/List_of_cities_proper_by_population">Wikipedia</a>'
                    // },
                    xAxis: {
                        type: 'category',
                        labels: {
                            // rotation: -45  // 设置轴标签旋转角度
                        }
                    },
                    yAxis: {
                        min: 0,
                        title: {
                            text: '热门实验（次）'
                        }
                    },
                    legend: {
                        enabled: false
                    },
                    tooltip: {
                        pointFormat: '实验总人次: <b>{point.y:.1f} 人次</b>'
                    },
                    series: [{
                        name: '总人口',
                        data: [
                            ['智能交互式游戏开发任务2：编写Python flask程序', 11.0],
                            ['智能交互式游戏开发任务3：简单实现贪吃蛇API', 11.0],
                            ['AI 博弈平台开发任务2：编写Python flask程序', 3],
                        ],
                        dataLabels: {
                            enabled: true,
                            rotation: -90,
                            color: '#FFFFFF',
                            align: 'right',
                            format: '{point.y:.1f}', // :.1f 为保留 1 位小数
                            y: 10
                        }
                    }]
                },
                model1:'0',
                model2:'0',
                model4:'0',
                courseArr:[
                    {
                        value:'0',
                        title:'全部学院'
                    },
                    {
                        value:'1',
                        title:'人工智能学院'
                    }
                ],
                classArr:[
                    {
                        value:'0',
                        title:'全部班级'
                    },
                    {
                        value:'1',
                        title:'人工智能体验一班'
                    }
                ],
                statusArr:[
                    {
                        value:'0',
                        title:'全部状态'
                    },
                    {
                        value:'1',
                        title:'进行中'
                    },
                    {
                        value:'1',
                        title:'已完成'
                    }
                ],
                datas: [
                    {
                        className:'人工智能体验一班',
                        stuName:'测试团团',
                        studentID:'123456',
                        courseName:'人工智能课程实训-AI 博',
                        labName:'智能交互式游戏开发任务2：编写Python flask程序',
                        manTime:'2人次',
                        status:'已完成'
                    },
                    {
                        className:'人工智能体验一班',
                        stuName:'测试团团',
                        studentID:'123456',
                        courseName:'人工智能课程实训-AI 博',
                        labName:'智能交互式游戏开发任务2：编写Python flask程序',
                        manTime:'2人次',
                        status:'已完成'
                    },
                    {
                        className:'人工智能体验一班',
                        stuName:'测试团团',
                        studentID:'123456',
                        courseName:'人工智能课程实训-AI 博',
                        labName:'智能交互式游戏开发任务2：编写Python flask程序',
                        manTime:'2人次',
                        status:'已完成'
                    }
                ],
                columns: [
                    {
                        title: '课程名称',
                        key: 'courseName',
                        tooltip:true
                    },
                    {
                        title: '实验名称',
                        key: 'labName',
                        tooltip:true
                    },
                    {
                        title: '累计上机人次',
                        key: 'manTime',
                        sortable: true
                    },
                    {
                        title: '学生名称',
                        key: 'stuName'
                    },
                    {
                        title: '学号',
                        key: 'studentID',
                        sortable: true
                    },
                    {
                        title: '所属班级',
                        key: 'className',
                        sortable: true
                    },
                    {
                        title: '状态',
                        key: 'status'
                    },

                ],
            }
        }
    }
</script>

<style scoped lang="less">
    @import "../../../style/index";
</style>